<template>
 
  <div class="faixa bg-verde-esc">
   </div>
   <a name="be-a-part"></a>
   <div class="row bg-verde-esc">
     <div class="col-12 col-md-6">
       <div class="content">

       <div class="content_be_part">
         <h1 class="cor-azul">Be a part</h1>
         <span class="amarelo f-4">
           <br>
 
           If your hotel or restaurant shares our vision for a more sustainable and meaningful guest experience, we invite you to become part of the AWA journey. Together, we can offer not just water — but a story of hope, care, and connection with nature



<br><br>
Contact us today to become a representative.
<br><br>
<component_bt_contact buttonText="Contact Us" buttonClass="btnx1" />
          </span>

          </div>



       </div>
     </div>
     <div class="col-12 col-md-6" style="text-align: right;">
       <img class="img-fluid" :src="'awa-bottles.jpg'" alt="AWA Bottles">
     </div>
   </div>
   <div class="faixa bg-verde-esc">
    &nbsp;
   </div>
  
 </template>
 
 <script>

 import component_bt_contact from '@/components/component_bt_contact.vue'



export default {


  components: {
    component_bt_contact,
  },

  data() {
    return {};
  }
};


 </script>
 
 <style scoped>
 :root {
   --cream: #E0D0A6;
   --blue: #6FD0E7;
   --blue2: #83DEF4;
   --green: #536D3F;
   --mid-green: #475C37;
   --dark-green: #3D4D31;
   --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
 }
 
 * {
   box-sizing: border-box;
 }
 
 body, html {
   overflow-x: hidden;
   overflow-y: auto;
 }
 
 .row {
   max-height: 100vh;
   overflow: hidden;
 }
 
 
 .bg-verde-esc {
   background-color: var(--dark-green);
 }
 
 .cor-azul {
   color: var(--blue);
 }
 
 .amarelo {
   color: var(--cream);
 }
 
  
 h1 {
   font-family: var(--object-sans);
   font-size: 6rem;
   font-weight: 400;
 }
 
 .f-4 { 
  
  font-size: 2.1rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;

 } /* Um pouco menor */
 
  
 .img-fluid {
     max-width: 100%;
     height: auto;
     margin: 0 auto;
 }
  
 .faixa {
   padding: 8rem;
 }
 
 .content {
     padding: 4rem;
     margin: 8rem;
     text-align: left;
   }
 
   .border-log {
       border: 1px solid red;
   }
 
 
 /* SE FOR NA TELA DE CELULAR PEQUENA */
 
 @media screen and (max-width: 640px) {
 
   .img-fluid {
     max-width: 90%;
     height: auto;
     object-fit: contain;
 
     display: flex;
     justify-content: center; /* Alinha horizontalmente */
     align-items: center;     /* Alinha verticalmente */    
 
 }
 
 
   .faixa {
     padding: 4rem;
     margin: 0;
 }
 
   h1 {
     font-size: 4rem;
   }
 
   .border-log {
       border:  1px solid rgb(0, 0, 255);
   }
 
   .content {
     padding: 2rem;
     margin: 0;
     text-align: left;
   }
 
   .content_be_part {
    padding-left: 3rem;
    padding-right: 2rem;
  }
 

   .row {
     flex-direction: column;
     text-align: center;
   }
 
   .col-12 {
     flex: 0 0 100%;
     max-width: 100%;
   }
 
   .col-md-6 {
     flex: 0 0 100%;
     max-width: 100%;
   }
 
   .f-4 { font-size: 1.8rem; letter-spacing: 0.04rem; line-height: 2.4rem;} /* Um pouco menor */
 
  
 }
 
 
 
 
 
 
 
  
 </style>
 